import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'
import { LinkField, MenuLinkField } from '@/payload-types'
import { getCtaUrl, getLinkUrl } from '@/utilities/getLink'

const LinkWrapper = ({
  link,
  children,
  className,
}: {
  link: LinkField
  children?: React.ReactNode
  className?: string
}) => {
  if (!link.enabled) return null

  if (link.type === 'external' && link.url) {
    return (
      <a
        href={link.url}
        target='_blank'
        rel='noopener noreferrer'
        className={cn('hover:opacity-50 transition-opacity', className)}
      >
        {children}
      </a>
    )
  }

  const ctaUrl = getCtaUrl(link)

  if (!ctaUrl) return null

  return (
    <Link href={ctaUrl} className={cn('hover:opacity-50 transition-opacity', className)}>
      {children}
    </Link>
  )
}

export default LinkWrapper

export const MenuLinkWrapper = ({
  link,
  children,
  className,
}: {
  link: MenuLinkField
  children?: React.ReactNode
  className?: string
}) => {
  if (link.type === 'custom' && link.url) {
    return (
      <a
        href={link.url}
        target={link.newTab ? '_blank' : '_self'}
        rel='noopener noreferrer'
        className={cn('hover:opacity-50 transition-opacity duration-300', className)}
      >
        {children}
      </a>
    )
  }

  const linkUrl = getLinkUrl(link)

  if (!linkUrl) return null

  return (
    <Link
      href={linkUrl}
      target={link.newTab ? '_blank' : '_self'}
      className={cn('hover:opacity-50 transition-opacity', className)}
    >
      {children}
    </Link>
  )
}
